module.exports = __webpack_public_path__ + "static/img/top-bg.503b78b8.webp";